import React from 'react'

const MatxLogo = ({ className }) => {
    return <img src="/logo.png" alt="logo" style={{ width: '100%' }} />
}

export default MatxLogo
